export enum NotificationMessageType {
  error = 'error',
  warning = 'warning',
}
